import pub from './../public'
const type = pub.getLang();

const language={
    "zh-hk":{
        loginLang:"登入",
        SMSErrorLang:'驗證碼錯誤，請重新輸入',
        NoInterNetLang:'沒有網絡連線，請檢查後重試',
        nextLang:'下一步',
        loginLang:'登入',
        continueLang:'確定',
        cancelLang:'取消',
        getCodeLang:'獲取驗證碼',
        after60Lang:'s後重新獲取',
        fastLoginLang:'快捷登入/註冊',
        userLoginLang:'會員密碼登入',
        agreeLang:'已閱讀及同意',
        subtit:'本人同意接收有關House730的最新資訊、會員優惠及業務合作夥伴的推廣資料。',
        house730Lang:'House730服務條款',
        schoolLang:'登入/註冊教學',
        emailLoginLang:'電郵地址登入',
        telLoginLang:'手提電話登入',
        resetWayLang:'選擇重置密碼方式',
        resetPasswordLang:'重設密碼',
        passwordResetSuccessLang:'您的新密碼已設置成功',
        telLang:'轉用手提電話',
        emailLang:'轉用電郵地址',
        forgetPasswordLang:'忘記密碼',
        telPointLang:'請輸入手提電話',
        newsPointLang:'訂閱通訊電郵',
        SMSPointLang:'請輸入SMS驗證碼',
        emailPointLang:'請輸入電郵地址',
        ImgPointLang:'請輸入圖形驗證碼',
        passwordPointLang:'請輸入密碼',
        resetPasswordPointLang:'請輸入6-20位英文數字組合密碼',
        againPasswordPointLang:'請再次確認新密碼',
        errTelLang:'請輸入正確的手提電話',
        errTelFormLang:'請輸入正確格式的手提電話',
        errAllLang:'賬號或密碼輸入錯誤，請重新輸入',
        errMaxLang:'賬號多次輸入錯誤，請聯絡我們 36193200',
        // errEmailFormLang:'請輸入正確格式的電郵地址',
        errEmailFormLang:'請輸入正確的電郵格式',
        errPasswordFormLang:'密碼格式錯誤，請重新輸入',
        errNoTelLang:'該手提電話未有註冊',
        errNoEmailLang:'該电邮地址未有註冊',
        errSamePasswordLang:'兩次密碼不一致，請重新輸入',
        webResetLang:'請選擇重置密碼的方式，輸入驗證碼後再進行下一步',
        webSuccessLang:'您已通過驗證，請設置新的密碼',
        userSetLang:'賬號設置',
        userValidatorLang:'賬號驗證',
        setNewPasswordLang:'設置新密碼',
        successLang:'完成',
        newPasswordLang:'輸入新密碼',
        makeSureLang:'確認新密碼',
        tremsUrl:'/my/help?id=3',
        agreeNoticeLang:'您還沒有同意House730服務條款，請閱讀點擊同意後再登入！',
        hasPasswordLang:'你的賬號還未設置密碼，請使用快捷驗證登入',
        codeNumLang:'獲取驗證碼次數過多，請稍後再試',
        emailSendlang:'電子郵件已發送'
    },
    "zh-cn":{
        loginLang:"登入",
        SMSErrorLang:'验证码错误，请重新输入',
        NoInterNetLang:'没有网络连线，请检查后重试',
        nextLang:'下一步',
        loginLang:'登入',
        continueLang:'确定',
        cancelLang:'取消',
        getCodeLang:'获取验证码',
        after60Lang:'s后重新获取',
        fastLoginLang:'快捷登入/注册',
        userLoginLang:'会员密码登入',
        agreeLang:'已阅读及同意',
        subtit:'本人同意接收有关House730的最新资讯、会员优惠及业务合作伙伴的推广资料',
        house730Lang:'House730服务条款',
        schoolLang:'登入/注册教学',
        emailLoginLang:'电邮地址登入',
        telLoginLang:'手提电话登入',
        resetWayLang:'选择重置密码方式',
        resetPasswordLang:'重设密码',
        passwordResetSuccessLang:'您的新密码已设置成功',
        telLang:'手提电话',
        emailLang:'电邮地址',
        forgetPasswordLang:'忘记密码',
        telPointLang:'请输入手提电话',
        newsPointLang:'订阅通讯电邮',
        SMSPointLang:'请输入SMS验证码',
        emailPointLang:'请输入电邮地址',
        ImgPointLang:'请输入图形验证码',
        passwordPointLang:'请输入密码',
        resetPasswordPointLang:'请输入6-20位英文数字组合密码',
        againPasswordPointLang:'请再次确认新密码',
        errTelLang:'请输入正确的手提电话',
        errTelFormLang:'请输入正确格式的手提电话',
        errAllLang:'账号或密码输入错误，请重新输入',
        errMaxLang:'账号多次输入错误，请联络我们 36193200',
        errEmailFormLang:'请输入正确的电邮格式',
        errPasswordFormLang:'密码格式错误，请重新输入',
        errNoTelLang:'该手提电话未有注册',
        errNoEmailLang:'该电邮地址未有注册',
        errSamePasswordLang:'两次密码不一致，请重新输入',
        webResetLang:'请选择重置密码的方式，输入验证码后再进行下一步',
        webSuccessLang:'您已通过验证，请设置新的密码',
        userSetLang:'账号设置',
        userValidatorLang:'账号验证',
        setNewPasswordLang:'设置新密码',
        successLang:'完成',
        newPasswordLang:'输入新密码',
        makeSureLang:'确认新密码',
        tremsUrl:'/my/zh-cn/help?id=3',
        agreeNoticeLang:'您还没有同意House730服务条款，请阅读点击同意后再登入！',
        hasPasswordLang:'你的账号还未设置密码，请使用快捷验证登入',
        codeNumLang:'获取验证码次数过多，请稍后再试',
        emailSendlang:'电子邮件已发送'
    },
    "en-us":{
        loginLang:"Login",
        SMSErrorLang:'Incorrect verification code, please enter again',
        NoInterNetLang:'No internet connection, please try again later',
        nextLang:'Next',
        loginLang:'Login',
        continueLang:'Continue',
        cancelLang:'Cancel',
        getCodeLang:'Get code',
        after60Lang:'Get again after ',
        fastLoginLang:'SMS Login',
        userLoginLang:'Password Login',
        agreeLang:'I have read and agreed with',
        subtit:'I agree to receive the latest news about House730, member discounts and promotion materials from business partners.',
        house730Lang:' House730 Terms & Conditions',
        schoolLang:'Login/Register Tutorial',
        emailLoginLang:'Email',
        telLoginLang:'Mobile No.',
        resetWayLang:'Reset Password',
        resetPasswordLang:'Reset Password',
        passwordResetSuccessLang:'New password is set',
        telLang:'Mobile No.',
        emailLang:'Email',
        forgetPasswordLang:'Forgot Password',
        telPointLang:'Your mobile no.',
        newsPointLang:'Subscription Email',
        SMSPointLang:'SMS verification code',
        emailPointLang:'Your email',
        ImgPointLang:"Enter picture's code",
        passwordPointLang:'Enter your password',
        resetPasswordPointLang:'Please enter 6-20 characters password with alphabets and numbers',
        againPasswordPointLang:'Re-enter new password',
        errTelLang:'Correct mobile no.',
        errTelFormLang:'Please enter correct mobile no.',
        errAllLang:'Incorrect username or password, please enter again',
        errMaxLang:'Incorrect input for many times, please contact us at 36193200',
        errEmailFormLang:'Please input correct email address',
        errPasswordFormLang:'Incorrect format of password, please enter again',
        errNoTelLang:'no registration',
        errNoEmailLang:'no registration',
        errSamePasswordLang:'Passwords do not match, please enter again',
        webResetLang:'Please choose the way to reset your password, enter the verification code to continue',
        webSuccessLang:'Verification successful, please enter your new password',
        userSetLang:'Account Setting',
        userValidatorLang:'Account Verification',
        setNewPasswordLang:'Add new password',
        successLang:'Done',
        newPasswordLang:'Enter new password',
        makeSureLang:'Confirm new password',
        tremsUrl:'/my/en-us/help?id=3',
        agreeNoticeLang:"You haven't agree with House730 Terms & Conditions, please read, tap agree and login again!",
        hasPasswordLang:"You haven't set the password, plaese use SMS Login.",
        codeNumLang:'You have exceeded max. no. of requests, please try again later',
        emailSendlang:'Email has been sent'
        
    },
}
export default language[type]